import CommandeAEnvoyerI18n from './CommandeAEnvoyer.i18n.js'
import {
  mapActions,
  mapGetters
} from 'vuex'

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['commandesLoading', 'commandes'])
  },

  data() {
    return {
      currentDisplay: 'nouv',
      currentCommande: null
    };
  },

  watch: {},

  methods: {
    ...mapActions(['getCommandesAEnvoyer', 'shipCommande', 'cancelCommande']),
    // General
    displaySection(pCurrentDisplay) {
      this.currentDisplay = pCurrentDisplay
    },
    /**
     * Modale de détail des articles.
     * @param {*} pCommande 
     */
    openModalDetailCommande(pCommande) {
      this.currentCommande = pCommande
      this.$refs['modal-detail-commande'].show()
    },
    closeModalDetailCommande() {
      this.$refs['modal-detail-commande'].hide()
    },
    /**
     * Modale de validation de la commande.
     * @param {*} pCommande 
     */
    openModalExpeditionCommande(pCommande) {
      this.currentCommande = pCommande
      this.$refs['modal-expedition-commande'].show()
    },
    closeModalExpeditionCommande() {
      this.$refs['modal-expedition-commande'].hide()
    },
    /**
     * Modale d'annulation de la commande.
     * @param {*} pCommande 
     */
    openModalCancelCommande(pCommande) {
      this.currentCommande = pCommande
      this.$refs['modal-cancel-commande'].show()
    },
    closeModalCancelCommande() {
      this.$refs['modal-cancel-commande'].hide()
    },
    /**
     * Prix d'une ligne.
     * @param {*} pArticle 
     * @returns 
     */
    getTotalPrixLigne(pArticle) {
      return (pArticle.pivot.quantite * pArticle.pivot.prix_unit * (1 - pArticle.pivot.reduction / 100)).toFixed(2)
    },
    /**
     * Prix d'une commande.
     * @param {*} pCommande 
     * @returns 
     */
    getTotalCommande(pCommande) {
      let total = 0
      pCommande.articles.forEach(article => {
        total = this.getTotalPrixLigne(article) + total
      })
      total = parseFloat(total).toFixed(2)
      return total
    },

    /**
     * Fonction pour annuler la commande.
     */
    cancelCurrentCommande() {
      this.cancelCommande(this.currentCommande).then(res => {
        this.$refs['modal-cancel-commande'].hide()
        this.getCommandesAEnvoyer().then(res => {

        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
    /**
     * Fonction pour expédier la commande.
     */
    shipCurrentCommande() {
      this.shipCommande(this.currentCommande).then(res => {
        this.$refs['modal-expedition-commande'].hide()
        this.$refs['modal-detail-commande'].hide()
        this.getCommandesAEnvoyer().then(res => {

        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
      })
    },
  },

  filters: {
    currency: (value) => {
      const formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return formatter.format(value);
    }
  },

  mounted() {
    this.getCommandesAEnvoyer().then(res => {

    }).catch(err => {
      console.log(err)
    })
  },

  i18n: CommandeAEnvoyerI18n,

};